import firestore from '../firestore'

function defaultNoteTemplate () {
  return {
    name: 'Example Note Template',
    description: 'An example not template...',
    enabled: false,
    sourceNoteTemplateId: null,
    template: `class Template {
  /**
   * Called when a tree node needs to be generated for this note.
   * For properties of returned object...
   * @see https://quasar.dev/vue-components/tree#Nodes-model-structure
   */
  formatTreeItem () {
    return { icon: this.unlocked ? 'lock open' : 'lock' }
  }

  /**
   * Decode a note from its server stored value.
   * Should return a modified version of unprocessedNote.
   * This function will be called any time the server sends
   * this client an updated note.
   * @param unprocessedNote {*} A copy of the unprocessed note from the server (modify and return this).
   */
  decode (unprocessedNote) {
    /* Modify unprocessedNote and then return it.
       Or return it unmodified. */
    return unprocessedNote
  }

  /**
   * Called before the item is saved to the remote database.
   * The param passed is a copy of this.note which should be modified and
   * returned.  If null is returned then the save will be cancelled.
   * @param noteCopy  A copy of the item to be saved (modify and return this).
   */
  encode (noteCopy) {
    return noteCopy
  }

  /**
   * Configure the note editor.
   * Pass a vue-config object to replace the entire view
   * with a new vue element.  Alternatively, pass a
   * configuration object to configure which editors are
   * allowed/visible and to add any extra buttons to the
   * toolbar.
   * @see doc
   * @returns {*}
   */
  configureEditor (config) {
    // config.splits['customView'] = {visible: false, index: 0, icon: 'mdi-code-braces', locked: false, name: 'User Data', content: 'editor'}
    // For example hide the 'data' (markdown) editor:
    // config.splits['data'].visible = false
    return config
  }

  /**
   * This function is called each time the note is accessed for viewing.  For
   * example, every time a new note is clicked in the tree view.  This is called
   * before configureEditor.
   * Has access to the note through this.note.
   * Should return a promise.  The read/render will be blocked until this promise
   * resolves.
   */
  onAccess () {
    /* Potentially long-running promise here such as showing the
       user a dialog */
  }
}`,
    createdAt: new Date(),
    updatedAt: new Date()
  }
}

function sanitiseNoteTemplate (unsanitisedNoteTemplate) {
  return {
    name: unsanitisedNoteTemplate.name || 'Unnamed Note Template',
    description: unsanitisedNoteTemplate.description || '',
    enabled: unsanitisedNoteTemplate.enabled || false,
    sourceNoteTemplateId: unsanitisedNoteTemplate.sourceNoteTemplateId || null,
    template: unsanitisedNoteTemplate.template || '',
    updatedAt: unsanitisedNoteTemplate.updatedAt || new Date(),
    createdAt: unsanitisedNoteTemplate.createdAt || null,
    scripts: unsanitisedNoteTemplate.scripts || []
  }
}

export const addNoteTemplate = ({ state, dispatch }, noteTemplate) => {
  let sanitised = {}
  if (noteTemplate == null) {
    sanitised = defaultNoteTemplate()
  } else {
    sanitised = sanitiseNoteTemplate(noteTemplate)
  }
  let ref = firestore.noteTemplatesColRef.doc()
  return ref.set(sanitised).then(() => {
    return ref.id
  })
}

export const updateNoteTemplate = ({ state, commit }, noteTemplate) => {
  let sanatised = sanitiseNoteTemplate(noteTemplate)
  // console.log('update noteTemplate')
  // console.log(sanatised.code.desc)
  // console.log(state.noteTemplates[noteTemplate.id].code.desc)
  return firestore.noteTemplatesColRef.doc(noteTemplate.id).set(sanatised)
}

export const deleteNoteTemplateWithId = ({ state }, noteTemplateId) => {
  return firestore.noteTemplatesColRef.doc(noteTemplateId).delete()
}
